package com.example.mystybag.core.model

data class PendingSnackbar(
    val config      : SnackbarConfig,
    //val continuation: CancellableContinuation<SnackbarResult>
)